import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../../store'
import { selectSelf } from '..'
import { UIState } from '../../reducers/common/ui'

export const selectUIState = createSelector(selectSelf, (state: RootState) => state.ui)
export const selectPages = createSelector(selectUIState, (state: UIState) => state.pages)
export const selectModal = createSelector(selectUIState, (state: UIState) => state.modal)
